import { createSlice } from "@reduxjs/toolkit";
const initialState = {
  isPanelClosed: false,
  userName: "",
  key: "ROP"
};
const LoginPanelSlice = createSlice({
  name: "loginpanel",
  initialState,
  reducers: {
    setTabKey: (state, action) => {
      state.key = action.payload;
    },
    setIsPanelClosed: (state, action) => {
      state.isPanelClosed = action.payload;
    },
    setUserName: (state, action) => {
      state.userName = action.payload;
    },
    clearUserName: state => {
      state.userName = "";
    }
  }
});
export const {
  setIsPanelClosed,
  setUserName,
  clearUserName,
  setTabKey
} = LoginPanelSlice.actions;
export default LoginPanelSlice.reducer;